<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';
import type { Message } from '../types/chat';

interface Props {
    message: Message;
}

const props = defineProps<Props>();

const comment = ref('');
const textarea = ref<HTMLTextAreaElement | null>(null);
const form = ref<HTMLFormElement | null>(null);

const showForm = computed(() => {
    return props.message.feedback?.rating && props.message.feedback?.comment === undefined;
});

watch(showForm, (isVisible) => {
    if (isVisible) {
        nextTick(() => {
            const inputBar = document.querySelector('.chat__interface');

            if (inputBar && document.scrollingElement) {
                (document.scrollingElement as HTMLElement).style.scrollPaddingBottom = `${inputBar.clientHeight + 20}px`;
            }

            textarea.value?.focus({ preventScroll: true });
            form.value?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }
}, { once: true });

const handleSubmit = (event: Event) => {
    event.preventDefault();
    if (!props.message.feedback) {
        throw new Error('Feedback must have a rating before adding a comment');
    }
    props.message.feedback.comment = comment.value.trim();
};

const handleCancel = () => {
    if (!props.message.feedback) {
        return;
    }
    props.message.feedback.comment = false;
};
</script>

<template>
    <form
        v-if="showForm"
        ref="form"
        class="feedback-widget__comment"
        @submit="handleSubmit"
    >
        <label for="feedback-comment" class="feedback-widget__comment-label">
            Kommentar ergänzen (optional)
        </label>
        <textarea
            id="feedback-comment"
            ref="textarea"
            v-model="comment"
            class="feedback-widget__textarea"
            rows="3"
            placeholder="Dein Feedback …"
        ></textarea>
        <div class="d-flex gap-2 mt-2">
            <button
                type="submit"
                class="btn btn-sm btn-primary"
            >
                Kommentar absenden
            </button>
            <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="handleCancel"
            >
                Schließen
            </button>
        </div>
    </form>
</template>
